import * as React from 'react';
import { Link } from 'react-router-dom';

import { DataTableView, Column } from 'src/core/ui/data-table.view';

export class TaxListView extends React.Component<TaxListViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: TaxSummary) => <Link to={`/general/taxes/${record.id}`}>{text}</Link>,
			},
			{
				key: 'percent',
				title: 'Percent',
				dataIndex: 'percent' ,
				render: (text, record, index) => {
					return Math.round(record.percent * 100) + '%';
				}
			}
		];
		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }} />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/taxes/list/tax-list.view.tsx